import { __spreadArray } from "tslib";
import { useCallback } from 'react';
/**
 * Take a function and wrap it in a standard user input event function
 *
 * For reducing boilerplate when we just want an event's .target.value
 */
export function useEventValueCallback(func, extraDependencies) {
    if (extraDependencies === void 0) { extraDependencies = []; }
    return useCallback(function (e) {
        func(e.target.value);
    }, __spreadArray([func], extraDependencies, true));
}
//# sourceMappingURL=useEventValueCallback.js.map